module.exports = __webpack_public_path__ + "static/media/event-wcra.082c470a.svg";